import { Box, Group, Tabs, Text } from '@mantine/core'
import {
  IconFileDescription,
  IconLock,
  IconBox,
  IconBug,
} from '@tabler/icons-react'
import { DataEngineeringIntakeForm } from './DataEngineeringIntakeForm'
import { UserAccessForm } from './UserAccessForm'
import { SandboxProvisioningForm } from './SandboxProvisioningForm'
import { DataQualityForm } from './DataQualityForm'

// ---------------------------------------------------------------------------
// Requests hub: tabbed container hosting the four request form templates.
//
// 1. Data Engineering Intake — full medallion pipeline request (original form)
// 2. User Access Request — PRISM / Databricks / Genie access
// 3. Sandbox Provisioning — sandbox environment creation
// 4. Data Quality Issue — data accuracy / completeness issue report
//
// Each tab is a self-contained form that opens an Outlook compose window on
// submit (interim approach; future release will use Linear or similar).
// ---------------------------------------------------------------------------

export function Requests() {
  return (
    <Box>
      <Group justify="space-between" mb="lg">
        <div>
          <Text size="xl" fw={700} c="gray.9">
            Requests
          </Text>
          <Text size="sm" c="gray.6">
            Select a request type below and fill in the form. Submitting opens a
            prefilled Outlook email for review.
          </Text>
        </div>
      </Group>

      <Tabs defaultValue="data-engineering" keepMounted={false}>
        <Tabs.List mb="lg">
          <Tabs.Tab
            value="data-engineering"
            leftSection={<IconFileDescription size={16} />}
          >
            New Data Product
          </Tabs.Tab>
          <Tabs.Tab
            value="user-access"
            leftSection={<IconLock size={16} />}
          >
            User Access
          </Tabs.Tab>
          <Tabs.Tab
            value="sandbox"
            leftSection={<IconBox size={16} />}
          >
            Sandbox Provisioning
          </Tabs.Tab>
          <Tabs.Tab
            value="data-quality"
            leftSection={<IconBug size={16} />}
          >
            Data Quality Issue
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="data-engineering">
          <DataEngineeringIntakeForm />
        </Tabs.Panel>

        <Tabs.Panel value="user-access">
          <UserAccessForm />
        </Tabs.Panel>

        <Tabs.Panel value="sandbox">
          <SandboxProvisioningForm />
        </Tabs.Panel>

        <Tabs.Panel value="data-quality">
          <DataQualityForm />
        </Tabs.Panel>
      </Tabs>
    </Box>
  )
}
